// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"83":"9d70e3e28b3303dd","399":"492f0e2a2c166709","780":"26e1ab66dd5e6153","803":"b0de43d3ae09a578","965":"37d8af8dc085c9e1"}[chunkId] + ".css";
};